let NotificationService = /** @class */ (function () {
    /**
     * NF-820: Manage notification ( Register , UnRegister, Fire event when receive notification)
     * @param $q{angular.IQService}
     * @param $http{angular.IHttpService}
     * @param $Config{$Config}
     * @param AuthService{AuthService}
     * @param localStorageService{localStorageService}
     * @param NetworkInfoService{NetworkInfoService}
     * @param $message{$message}
     * @param $state{ui.IStateService}
     * @param DeviceService{DeviceService}
     * @param $mdPanel {$mdPanel}
     * @param $Loading{$Loading}
     * @param $timeout{angular.ITimeoutService}
     * @param AnnouncementService{AnnouncementService}
     * @param UtilityService{UtilityService}
     * 
     * @constructor
     */
    function NotificationService($q, $http, $Config, AuthService, localStorageService, NetworkInfoService, $message, 
                                 $state, DeviceService, $mdPanel, $Loading, $timeout, AnnouncementService, UtilityService, $translationService) {
        this.$q = $q;
        this.$http = $http;
        this.appConfig = $Config;
        this.authService = AuthService;
        this.localStorageService = localStorageService;
        this.networkInfoService = NetworkInfoService;
        this.$message = $message;
        this.$state = $state;
        this.deviceService = DeviceService;
        this.$mdPanel = $mdPanel;
        this.$Loading = $Loading;
        this.$timeout = $timeout;
        this.announcementService = AnnouncementService;
        this.utilityService= UtilityService;
        this.$translationService = $translationService;
        
        this.lastCheckUrgentNotifications = null;
    }


    NotificationService.prototype = {
        currentFirebaseToken: null,
        savePushNotificationRegistration$: null,

      
        //@type {boolean} isTapOnNotification - Flag to check if user tap on notification
        isTapOnNotification : false,

        // for cancel request count
        timerNotificationCountDefer: null,
        notificationCount: 0, // Count of notifications
        notificationCountLoaded: false, // Flag to check if notification count is loaded

        //@type {NotificationData} notificationData
        notificationData: null, // Notification data when user click on notification and app is not authed

        timerToLoadUrgentNotifications: null,
        
        //@type {boolean} isCheckingUrgentNotifications - Flag to indicate, app is checking(process) urgent notifications (prevent check 2 times same time)
        isCheckingUrgentNotifications: false,

        /** @type {MdPanelRef}  */
        currentDialogUrgentRef: null, // Panel ref of urgent dialog
        /** @type {NotificationModel} currentNotificationUrgent */
        currentNotificationUrgent: null,

        /** @type {MdPanelRef}  */
        panelRef: null, // Panel ref of normal dialog
        
        /** @type {NotificationModel} */
        _updateRecommended: null,
        
        /** @type {NotificationModel} */
        _whatsNew: null,

        /** @type {NotificationModel} */
        _pushNotification: null, 

        register() {
            if(window['cordova'] && window['FirebasePlugin']  ){
                // Refresh token when firebase-token was changes
                FirebasePlugin.onTokenRefresh(this.onTokenRefresh.bind(this), () => {
                    console.error('Refresh token error');
                });

                // Register notification event
                this.registerNotificationEvent();

                // Clear token if token is sent and user don't receive notification
                this.checkAndClearPushNotificationRegistration();
            }
        },

        /**
         * Unregister  notification for app
         *  - Clear token on Firebase server
         *  - Clean local in local
         *  - Clean token in server (NEOFLEET server)
         * @returns {angular.IPromise<boolean>}
         */
        unregister() {
            return this.$q((resolve, reject) => {
                FirebasePlugin.unregister(() => { // Un-register firebase message
                    let firebaseToken = this.localStorageService.get('firebaseToken');
                    if (firebaseToken) {
                        console.log('Notification token is unregister.')
                        this.localStorageService.remove('firebaseToken'); // Remove token in local
                        if(this.authService.isLoggedIn() && this.networkInfoService.connection){  // Remove token on server
                            this.savePushNotificationRegistration('').then(()=>{
                                resolve();
                            }).catch(()=>{
                                reject();
                            })
                        } else{
                            resolve();
                        }
                    } else {
                        resolve();
                    }
                }, () => {
                    reject();
                });
            });
        },

        /**
         * Get full URL
         * @param url {string}
         * @returns {*}
         */
        getUrl: function (url) {
            return this.appConfig.apiUrl + url;
        },
        /**
         * Register token with server
         * @param token {string}
         * @param options{*?}
         * @returns {angular.IHttpPromise<unknown>}
         */
        savePushNotificationRegistration(token, options) {
            if(!options){
                options ={}
            }
            options.headers = {
                ignoreAutoStopRequest: true
            }
            return this.$http.post(this.getUrl("mobile/Notification/SavePushNotificationRegistration"), {
                Token: token
            }, options);
        },


        /**
         * Handles received notifications
         * - For tapped notifications:
         *   1. Gets notification details
         *   2. Processes the notification
         *   3. Updates notification count
         * - For non-tapped notifications:
         *   Just updates the notification count
         * 
         * @param {object|NotificationData} notificationData The notification data received
         * @private
         */
        onNotificationReceived(notificationData) {
            console.log('[Notifications]: onNotificationReceived', notificationData);
            if (notificationData.tap) { // if click on notification
                // Set flag to track notification tap and reset after delay
                if(!this.authService.isLoggedIn() || !this.networkInfoService.connection){
                    return;
                }

                this.isTapOnNotification = true;
                this.$timeout(() => {
                    this.isTapOnNotification = false;
                }, 500);
                this.getNotification(notificationData.id)
                    .then((notification) => {
                        return this.tapOnNotification(notification);
                    }, this.$message.error)
                    .then(() => {
                        // Update notification count after processing
                        this.checkNotificationCount();
                    });
            } else {
                // Just update notification count for non-tap notifications
                this.checkNotificationCount();
            }
        },

        /** @private */
        registerNotificationEvent() {
            // Received notification directly
            FirebasePlugin.onMessageReceived((data) => {
                this.onNotificationReceived(data);
            }, (error) => {
                console.error("Error receiving push message: ", error);
            });
        },

        /**
         * Fire when firebase token was refresh
         *  - Send token to server if token was changed
         * @param token {string}
         * @private
         */
        onTokenRefresh(token) {
            if (!token || !this.appConfig.hasNotificationPermission || !this.authService.isLoggedIn() || !this.networkInfoService.connection) {// Ignore if token is null or not permission
                return;
            }
            
            let oldFirebaseToken = this.localStorageService.get('firebaseToken');
            if (oldFirebaseToken !== token && this.currentFirebaseToken !== token) { // Token is changed
                console.log('onTokenRefresh: ', token, oldFirebaseToken);

                // cancel save token if token is saving
                if (this.canceler) {
                    console.log('cancel save token:'+ this.currentFirebaseToken);
                    this.canceler.resolve();
                }

                this.currentFirebaseToken = token;
                this.canceler = this.$q.defer();
                let options = {
                    timeout: this.canceler.promise
                };
                this.savePushNotificationRegistration(token, options).then(() => { // register token
                    // Update token
                    this.localStorageService.set('firebaseToken', token); // store token
                    
                    console.log('SavePushNotificationRegistration successful: ' + token);
                }, () => {
                    this.$message.error("Can't register  notification for current user"); // show error if register error
                    console.error('SavePushNotificationRegistration fail: ' + token);
                }).finally(()=>{
                    this.canceler = null;
                });
            }
        },
        
        /**
         * Clear token on server if user don't allow permitted notification
         */
        checkAndClearPushNotificationRegistration() {
            if (!this.appConfig.hasNotificationPermission)  { // have not permission and clear token on server
                this.unregister();
            }
        },

        /**
         * NF-944: Checks the notification count based on several conditions:
         * - User is logged in
         * - App is in foreground
         * - Has network connection
         * - App is running on Cordova
         *
         * Implements rate limiting to prevent checking too frequently:
         * - By default, only checks once per minute
         * - Can force immediate check by passing checkImmediately=true
         *
         * Updates the notification count badge:
         * - Fetches latest count from server
         * - Caps displayed count at 99
         * - Handles cancellation of in-flight requests
         *
         */
        checkNotificationCount() {
            // Only proceed if all required conditions are met
            if (this.authService.isLoggedIn() &&  // User is logged in
                !this.deviceService.isAppInBackground && // App is in foreground
                this.networkInfoService.connection && // Has network connection
                this.isHomeScreen() && // Is home screen
                !this.authService.showingUpdateRequired() &&  // Not showing update required
                !this.authService.showingChangePassword  // Not showing change-password
            ) {
                // Cancel any pending request
                if (this.timerNotificationCountDefer) {
                    this.timerNotificationCountDefer.resolve();
                    this.timerNotificationCountDefer = null;
                }

                // Create new deferred for this request
                this.timerNotificationCountDefer = this.$q.defer();

                // Fetch notification count
                this.getNotificationCount({timeout: this.timerNotificationCountDefer.promise}).then((count) => {
                    // Cap displayed count at 99
                    this.updateNotificationCount(count >= 99 ? 99 : count);
                }).finally(() => {
                    // Cancel any pending request
                    if (this.timerNotificationCountDefer) {
                        this.timerNotificationCountDefer.resolve();
                        this.timerNotificationCountDefer = null;
                    }
                });
            }
        },
        
        /**
         * NF-944: Get all notifications for this user
         * @returns {angular.IPromise<NotificationModel[]>}
         */
        getNotifications() {
            return this.$http.get(this.getUrl("mobile/Notification/Find"), {params: {language: this.$translationService.getCurrentLanguageCode() || 'en'}})
                .then((response) => {
                    /** @type {NotificationModel[]} */
                    let notifications = response.data;
                    notifications.forEach((item) => {
                        item.Urgent = this.isUrgent(item);
                    });
                    return notifications;
                });
        },

        /**
         * NF-944: Get details of notification by id
         * @param id{string}
         * @returns {angular.IPromise<NotificationModel>}
         */
        getNotification(id) {
            return this.$http.get(this.getUrl("mobile/Notification/GetNotification"), {params: {id: id, language: this.$translationService.getCurrentLanguageCode() || 'en'}})
            .then( (response)=>{
                /** @type {NotificationModel} */
                let notification = response.data;
                notification.Urgent = this.isUrgent(notification);
                return notification;
            });
        },


        /**
         * NF-944: Mark notification as read
         * @param item{NotificationModel}
         * @returns {any}
         */
        mapNotification: function(item){
            let clone = JSON.parse(JSON.stringify(item));
            if(clone.KeyValueData){
                let keyValueData = {};
                try {
                    keyValueData = JSON.parse(clone.KeyValueData);
                } catch (e) {
                }
                
                if(keyValueData.Vehicle){
                    clone.Vehicle = keyValueData.Vehicle;
                }
                if(keyValueData.ChargingPoint){
                    clone.ChargingPoint = keyValueData.ChargingPoint;
                }
                if(keyValueData.Date){
                    clone.Date = keyValueData.Date;
                }
                if(keyValueData.Time){
                    clone.Time = keyValueData.Time;
                }
            }
            return clone;
        },
        
        /**
         * NF-944: Count all notification to show badge
         * @param options{IRequestShortcutConfig}
         * @returns {angular.IPromise<number>}
         */
        getNotificationCount: function (options) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.get(this.getUrl("mobile/Notification/Count"), options).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        },

        /**
         * NF-944: Marks a notification as read
         * @param id{string}
         * @returns {angular.IPromise<*>}
         */
        markAsRead: function (id) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/Notification/MarkAsRead"), {Id: id}).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        },

        /**
         * NF-944: Mark all notifications as read
         * @returns {angular.IPromise<unknown>}
         */
        getNotificationMarkAllAsRead: function () {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/Notification/MarkAllAsRead")).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        },

        /**
         * NF-947: Retrieve notification settings
         * @returns {angular.IPromise<NotificationSettingsModel>}
         */
        getNotificationSettings: function () {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.get(this.getUrl("mobile/Notification/GetNotificationSettings")).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        },

        /**
         * NF-947: Save notification settings
         * @param settings {NotificationSettingsModel}
         * @returns {angular.IPromise<unknown>}
         */
        saveNotificationSettings: function (settings) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/Notification/SaveNotificationSettings"), settings).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        },
        
        /**
         * Processes a notification based on its type
         * 
         * For urgent notifications:
         * - Shows urgent notification dialog
         * 
         * For non-urgent notifications:
         * Handles different notification types:
         * - ConnectToChargingPointCancelled notifications (offline/not accessible)
         * - ChargeInterrupted notifications 
         * - OfflineChargingPoint notifications
         * - ChargeHasEnded notifications
         * - ReleaseChargingPoint notifications
         * - EventComment notifications
         * - ConnectToChargingPoint notifications
         * 
         * @param item {NotificationModel} The notification to process
         * @param [options] {INotificationOptions} Additional options for processing
         * @returns {angular.IPromise<any>} Promise that resolves when processing is complete
         */
        processNotification: function (item, options) {
            // Clear push/updateRecommended/whatsNew if matches
            if (this._pushNotification && item.Id === this._pushNotification.Id) {
                this._pushNotification = null;
            }
            if (this._updateRecommended && item.Id === this._updateRecommended.Id) {
                this._updateRecommended = null;
            }
            if (this._whatsNew && item.Id === this._whatsNew.Id) {
                this._whatsNew = null;
            }

            if (item.Urgent) {
                this.$Loading.hide(); // have to hide loading to show dialog
                return this.showUrgentNotificationDialog(item, options);
            } else {
                switch (item.Type) {
                    case 'ConnectToChargingPointCancelledChargingPointOffline': //NF-958
                    case 'ConnectToChargingPointCancelledChargingPointNotAccessible':
                    case 'ChargeInterruptedChargingPointOffline': //NF-964
                    case 'OfflineChargingPointUnassignedFromChargeBooking': //NF-965
                    case 'CancelReleaseChargingPoint': // NF-1173
                    case 'CancelConnectToChargingPoint': // NF-1173
                    case 'ChargeRequestCancelled': // NF-1173  
                        if (options && options.isNotificationOnNotificationsModule) {
                            this.$Loading.hide(); // have to hide loading to show dialog
                            return this.showSimpleDialog(item, options)
                        } else {
                            return this.markAsRead(item.Id).then(() => {
                                this.$Loading.hide(); // have to hide loading to show dialog
                                return this.showSimpleDialog(item, options)
                            });
                        }
                    case 'ChargeHasEnded'://NF-948
                        if (item.ChargingPointIsFree) {
                            this.$Loading.hide(); // Hide loading to show dialog
                            return this.showSimpleDialog(item, options);
                        } else {
                            return this.handleChargeHasEndedNotification(item);
                        }
                    case 'ReleaseChargingPoint': //NF-962
                        return this.markChargingPointAsFree(item.Id);
                    case 'EventAssignment':
                         return this.markAsRead(item.Id).then(() => {
                                this.$Loading.hide(); // have to hide loading to show dialog
                                return this.showEventCommentDialog({EventId: item.LinkedEntityId}, options);
                            });
                    case 'EventComment':
                        if (item.EventId === '00000000-0000-0000-0000-000000000000') { // Event is removed
                            return this.$q.resolve();
                        } else {
                            return this.markAsRead(item.Id).then(() => {
                                this.$Loading.hide(); // have to hide loading to show dialog
                                return this.showEventCommentDialog(item, options);
                            });
                        }
                    case 'ConnectToChargingPoint': //NF-949
                        return this.$q.resolve(); // Don't do anything because notification dismissed
                    case 'FuelLimitAlert': //NF-1002, Management of the notifications concerning FuelLimitAlert
                        return this.markAsRead(item.Id).then(() => {
                            return this.gotoFuelLimitAlert(options);
                        });
                    case 'Announcement':
                        return this.markAsRead(item.Id).then(() => {
                            this.$Loading.hide(); // have to hide loading to show dialog
                            return this.showAnnouncementDialog(item, options);
                       });
                    case 'NewDocument':
                        return this.markAsRead(item.Id).then(() => {
                            this.$Loading.hide(); // have to hide loading to show dialog
                            return this.gotoDocuments(options);
                        });
                    default:
                         return this.markAsRead(item.Id).then(() => {
                                this.$Loading.hide(); // have to hide loading to show dialog
                                return this.showSimpleDialog(item, options)
                            });
                        // return this.$q.resolve(); // Don't do anything because notification dismissed
                }
            }
        },
        
        /**
         * NF-948: Handles the notification if type is ChargeHasEnded
         * @param {NotificationModel} item - The notification item to handle
         * @returns {angular.IPromise} Promise that resolves when handling is complete
         */
        handleChargeHasEndedNotification: function (item) {
            return this.$q((resolve, reject) => {
                // Mark as read if ChargingPointIsFree is true
                if (item.ChargingPointIsFree) {
                    return this.markAsRead(item.Id).then(resolve, reject);
                } else {
                    return resolve();
                }
            }).then(() => {
                return this.$state.go("internal.home"); // go to home page
            })
        },

        /**
         * Recursively checks for urgent notifications and processes them
         * - Filters out non-urgent notifications
         * - If urgent notifications exist, shows dialog for first one
         * - After dialog closes, recursively checks for more urgent notifications
         * - Only continues recursion if user didn't navigate away
         * - Returns resolved promise if no urgent notifications
         *
         * @param {NotificationModel[]} items - Array of notifications to check
         * @returns {angular.IPromise<*>} Promise that resolves when all urgent notifications are processed
         */
        checkUrgentNotificationsRecursion: function (items) {
            if (items.length > 0) { // has urgent
                return this.processNotification(items[0]).then((result) => {
                    if (!(result && result.navigate)) {
                        return this.getUrgentNotifications().then((items) => {
                            return this.checkUrgentNotificationsRecursion(items);
                        });
                    } else {
                        return this.$q.resolve();
                    }
                });
            } else {
                return this.$q.resolve();
            }
        },
        
        /**
         * NF-944: Get urgent notifications from the server
         @returns {angular.IPromise<NotificationModel[]>} A promise that resolves to an array of urgent notifications 
         */
        getUrgentNotifications: function () {
            console.log('call getUrgentNotifications');
            return this.$http.get(this.getUrl("mobile/Notification/GetUrgentNotifications")).then((response) => {
                /** @type {NotificationModel[]} */
                let list = response.data;

                // Add to first if has push notification and it is urgent
                if(this._pushNotification && this._pushNotification.Urgent){ 
                    list.unshift(this._pushNotification); // add to first
                }
                
                // Add update recommended if has recommended
                if (this._updateRecommended) {
                    list.push(this._updateRecommended);
                }
                
                // Add whats new if has whats new
                if (this._whatsNew) {
                    list.push(this._whatsNew);
                }
                return list;
            });

        },

        /**
         * Shows an urgent notification dialog based on notification type
         *
         * Handles the following notification types:
         * - ChargeHasEnded (NF-948): Shows charge ended dialog
         * - ReleaseChargingPoint (NF-962): Shows release charging point dialog
         * - VehicleNotChargingNormally (NF-961): Shows vehicle not charging normally dialog
         * - ConnectToChargingPoint (NF-949): Shows connect to charging point dialog
         *
         * @param {NotificationModel} item - The notification to show dialog
         * @param {Object} [options] - Optional configuration
         * @param {boolean} [options.isNotificationOnNotificationsModule] - Whether notification is from notifications module
         * @param {MouseEvent} [options.$event] - Mouse event that triggered dialog
         * @returns {angular.IPromise<*>} Promise that resolves when dialog is closed
         */
        showUrgentNotificationDialog: function (item, options) {
            /** closeDialogPromise{angular.IPromise<*>}*/
            let closeDialogPromise;
            switch (item.Type) {
                case 'ChargeHasEnded': //NF-948
                    closeDialogPromise = this.showChargeHasEndedDialog(item, options);
                    break;
                case 'ReleaseChargingPoint': //NF-962
                    closeDialogPromise = this.showReleaseChargingPointDialog(item, options);
                    break;
                case 'VehicleNotChargingNormally': //NF-961
                    closeDialogPromise = this.showVehicleNotChargingNormallyDialog(item, options);
                    break;
                case 'ConnectToChargingPoint': //NF-949
                    closeDialogPromise = this.showConnectToChargingPointDialog(item, options);
                    break;
                case 'UpdateRecommended': //NF-1182, show update recommended dialog
                    closeDialogPromise = this.showUpdateRecommendedDialog(item, options);
                    break;
                case 'WhatsNew': //NF-1182 show whats new dialog
                    closeDialogPromise = this.showWhatsNewDialog(item, options);
                    break;
                default:
                    closeDialogPromise = this.showSimpleDialog(item, options);
            }
            return closeDialogPromise;

        },
        
        /**
         * Show notification dialog
         * @param item{NotificationModel}
         * @param controller{string}
         * @param templateUrl{string}
         * @param options{any}
         * @returns {angular.IPromise<any>}
         */
        showNotificationDialog(item, controller, templateUrl, options) {
            console.log('[Notification]: showNotificationDialog', item);
            if(!options) {
                options={};
            }
            return this.$q((resolve) => {
                /** @type {MdPanelRef} panelRef */
                let panelRef;
                let config = {
                    attachTo: document.body,
                    controller: controller,
                    templateUrl: templateUrl,
                    targetEvent: options.$event ? options.$event.target : null,
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: false,
                    panelClass: 'panel-md-dialog',
                    controllerAs: 'vm',
                    zIndex: 1000,
                    hasBackdrop: true,
                    locals: {
                        hide: (result)=>{
                            return panelRef.hide(result);
                        },
                        close: (result) => {
                            return panelRef.close(result).finally(() => {
                                // Clear current urgent dialog refs
                                this.currentDialogUrgentRef = null;
                                this.currentNotificationUrgent = null;
                                
                                resolve(result);
                            })
                        },
                        notification: item,
                        isNotificationOnNotificationsModule: options.isNotificationOnNotificationsModule
                    }
                };
                panelRef = this.$mdPanel.create(config);
                this.currentDialogUrgentRef = panelRef;
                this.currentNotificationUrgent = item;
                panelRef.open();
            });
        },

        /**
         * Show simple notification dialog
         * @param item{NotificationModel}
         * @param controller{string}
         * @param templateUrl{string}
         * @param $event{MouseEvent}
         * @returns {angular.IPromise<any>}
         */
        showSimpleNotificationDialog(item, controller, templateUrl, $event) {
            // console.log('[Notification]: showSimpleNotificationDialog', item);
            return this.$q((resolve) => {
                /** @type {MdPanelRef} panelRef */
                let panelRef;
                let config = {
                    attachTo: document.body,
                    controller: controller,
                    templateUrl: templateUrl,
                    targetEvent: $event ? $event.target : null,
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: false,
                    panelClass: 'panel-md-dialog',
                    controllerAs: 'vm',
                    hasBackdrop: true,
                    zIndex: 900,
                    locals: {
                        hide: (result)=>{
                            return panelRef.hide(result);
                        },
                        close: (result) => {
                            return panelRef.close(result).finally(() => {
                                this.panelRef = null;
                                resolve(result);
                            })
                        },
                        notification: item
                    }
                };
                panelRef = this.$mdPanel.create(config);
                this.panelRef = panelRef;
                panelRef.open();
            });
        },
        
        /**
         * NF-948: Open ChargeHasEnded urgent dialog
         * @param item {NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showChargeHasEndedDialog: function (item, options) {
            return this.showNotificationDialog(item, 'ChargeHasEndedController', 'js/internal/notifications/dialogs/charge-has-ended/charge-has-ended.html', options);
        },
        
        /**
         * NF-962: Open ReleaseChargingPoint urgent dialog
         * @param item{NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showReleaseChargingPointDialog: function (item, options) {
            return this.showNotificationDialog(item, 'ReleaseChargingPointController', 'js/internal/notifications/dialogs/release-charging-point/release-charging-point.html', options);
        },

        /**
         * NF-949: Open ConnectToChargingPoint urgent dialog
         * @param item{NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showConnectToChargingPointDialog: function (item, options) {
            return this.showNotificationDialog(item, 'ConnectToChargingPointController', 'js/internal/notifications/dialogs/connect-to-charging-point/connect-to-charging-point.html', options);
        },
        
        /**
         * NF-961: Open VehicleNotChargingNormally urgent dialog
         * @param item {NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showVehicleNotChargingNormallyDialog: function (item, options) {
            return this.showNotificationDialog(item, 'VehicleNotChargingNormallyController', 'js/internal/notifications/dialogs/vehicle-not-charging-normally/vehicle-not-charging-normally.html', options);
        },

        /**
         * NF-1182: Open UpdateRecommended urgent dialog
         * @param item {NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showUpdateRecommendedDialog(item, options){
            return this.showNotificationDialog(item, 'UpdateRecommendedDialog', 'js/shared/checking-new-version-dialog/update-recommended-dialog/update-recommended-dialog.html', options);
        },

        showWhatsNewDialog(item, options){
            return this.showNotificationDialog(item, 'DayTipController', 'js/internal/home/day-tip/day-tip.html', options);
        },
        
        /**
         * Show simple dialog
         * @param item{NotificationModel}
         * @param options{any}
         * @returns {angular.IPromise<*>}
         */
        showSimpleDialog: function (item, options) {
            return this.showSimpleNotificationDialog(item, 'SimpleDialogController', 'js/internal/notifications/dialogs/simple-dialog/simple-dialog.html', options);
        },
        
        /**
         * Mark charging point as free
         * @param notificationId{string}
         * @returns {angular.IPromise<void>}
         */
        markChargingPointAsFree: function(notificationId){
            return this.$q((resolve, reject) => {
                this.$http.post(this.getUrl("mobile/Notification/MarkChargingPointAsFree"), {id: notificationId}).then(() => {
                    resolve();
                }, reject);
            })
        },

        /**
         * Snooze notification
         * @param notification{NotificationModel}
         * @param minutes{number}
         * @returns {angular.IPromise<unknown>}
         */
        snoozeNotification: function (notification, minutes) {
            // Track snooze and minutes
            console.log('[Notifications] Remind ' + minutes + ' minutes for ' + notification.Id);
            
            return this.$http.post(this.getUrl('mobile/Notification/RemindMeLater'), {
                Id: notification.Id,
                Minutes: minutes
            });
        },

        /**
         * Close silent current urgent dialog
         * It means, it will cancel next urgent dialog if have
         * @returns {angular.IPromise<void>|*}
         */
        closeAllDialogUrgent() {
            let obs=[];
            if (this.panelRef) {
                obs.push(this.panelRef.close());
            }
            if (this.currentDialogUrgentRef) {
                obs.push(this.currentDialogUrgentRef.close());
            }
            return this.$q.all(obs).finally(()=>{
                this.panelRef = null;
                this.currentDialogUrgentRef = null;
                this.currentNotificationUrgent = null;
            });
        },
        
        /**
         * 
         * @param notification {NotificationModel}
         * @returns {(function(): void)|*}
         */
        blockUrgentNotifications(notification) {
            let urgent = notification.Urgent;
            if (urgent) {
                this.isCheckingUrgentNotifications = true;
            }
            return () => {
                if (urgent) {
                    this.isCheckingUrgentNotifications = false;
                }
            }
        },


        /**
         * Determine if urgent notifications can be checked
         * @returns {false|*|boolean}
         */
        shouldCheckUrgentNotifications() {
            return (this.networkInfoService.connection && // Has network connection
                this.authService.isLoggedIn() && // User is logged in
                !this.deviceService.isAppInBackground &&  // App is in foreground
                !this.authService.showingUpdateRequired() && // Not showing update required
                !this.authService.showingChangePassword && // Not showing change-password  
                !this.isCheckingUrgentNotifications // Is not checking urgent notifications 
            );
        },

        /**
         * NF-948: Checks and processes urgent notifications
         * Called when:
         * - Opening app without clicking notification
         * - Switching app to foreground
         * 
         * Logic:
         * 1. Skip if no network connection or not logged in
         * 2. Get urgent notifications from server
         * 3. If already checking an urgent notification:
         *    - Find if current notification still exists in urgent list
         *    - If exists and still urgent, do nothing
         *    - If exists but no longer urgent, close dialog and process normally
         *    - If doesn't exist, handle special case for ChargeHasEnded -> ReleaseChargingPoint
         * 4. If not already checking:
         *    - Start checking urgent notifications recursively
         *
         * @returns {angular.IPromise<*>} Promise that resolves when notifications are processed
         */
        checkUrgentNotifications() {
            this.lastCheckUrgentNotifications = moment();
            // console.log('checkUrgentNotifications');
            // Skip if no connection or not logged in
            if (!this.shouldCheckUrgentNotifications()) {
                return this.$q.resolve();
            }
            this.isCheckingUrgentNotifications = true;
            
            if (this.currentNotificationUrgent) {  
                // Note: Current urgent dialog is opening from "Notification module", "Required actions"
                // Don't check  if current urgent is WhatsNew or UpdateRecommended
                if (this.currentNotificationUrgent.Type === 'WhatsNew' || this.currentNotificationUrgent.Type === 'UpdateRecommended') {
                    this.isCheckingUrgentNotifications = false;
                    return this.$q.resolve();
                }
                // Issue: Auto close urgent dialog when notification is not urgent 
                // Get current notification from server to check if it still urgent
                //  - still urgent -> do nothing
                //  - not urgent -> close dialog
                return this.getNotification(this.currentNotificationUrgent.Id).then((currentNotification) => {
                    if (currentNotification.Urgent) {  // item is still urgent, don't do anything
                        return this.$q.resolve();
                    } else { // item is not urgent, close this urgent dialog and check urgent again
                        return this.closeAllDialogUrgent();
                    }
                }).finally(()=>{
                    this.isCheckingUrgentNotifications = false;
                })
            } else {
                return this.getUrgentNotifications().then((items) => {
                    return this.closeAllDialogUrgent().then(() => { // Close all  dialogs (normal dialog)
                        return this.checkUrgentNotificationsRecursion(items);
                    });
                })
                    // After processing urgent notifications, process normal notification
                    .then((value) => {
                        // Process normal notification
                        if (this._pushNotification && !this._pushNotification.Urgent) {
                            this.processNotification(this._pushNotification);
                        }
                        return value;
                    })
                    .finally(() => {
                        this.isCheckingUrgentNotifications = false; // checking urgent complete
                    });
            }
        },
        
        /**
         * Check urgent notification again if it realy urgent as the flag also mean that it urgent before
         *  when urgent is true and it unread -> realy urgent
         *  when urgent is true and read but it snooze (nextReminderOn not null) -> realy urgent
         *         
         * Check urgent notification
         * @param notification{NotificationModel}
         * @returns {boolean}
         */
        isUrgent(notification){
            if (notification.Urgent) {
                return notification.Unread === true || notification.NextReminderOn != null; // if the notification is snooze then we consider it still urgent
            } else {
                return false;
            }
        },

        /**
         * Process notification when click tap on push notification
         *  - If click on current urgent notification, do nothing
         *  - Otherwise, set push notification and check urgent notifications to run in orders
         * @param notification{NotificationModel}
         * @return angular.IPromise<any>
         */
        tapOnNotification(notification) {
            if (notification.Urgent && this.currentNotificationUrgent && notification.Id === this.currentNotificationUrgent.Id) {  // Click on the current urgent notification
                return this.$q.resolve();
            } else {
                this._pushNotification = notification;
                return this.checkUrgentNotifications();
            }
        },

        /**
         * Shows event comment dialog by navigating to event details
         * @param {NotificationModel} notification - The notification containing event details
         * @param {INotificationOptions} options - Additional options for handling the dialog
         * @returns {angular.IPromise} Promise that resolves when navigation is complete
         */
        showEventCommentDialog(notification, options) {
            return this.$timeout(()=>{
                return this.$state.go('internal.eventdetail', {
                    id: notification.EventId,
                    prevState: (options && options.isNotificationOnNotificationsModule) ? 'internal.notifications' : 'internal.home'
                });
            }, 500); // delay to fix error router when click on push notification (only iOS)
        },

        /**
         * Shows Announcement dialog by navigating to Announcement details
         * @param {NotificationModel} notification - The notification containing event details
         * @param {INotificationOptions} options - Additional options for handling the dialog
         * @returns {angular.IPromise} Promise that resolves when navigation is complete
         */
        showAnnouncementDialog(notification, options){
            return this.$timeout(()=>{
                return this.announcementService.gotToDetails(JSON.parse(notification.KeyValueData), (options && options.isNotificationOnNotificationsModule) ? 'internal.notifications' : 'internal.home');
            }, 500); // delay to fix error router when click on push notification (only iOS)
        },
        
        /**
         * Checks if current state is home screen
         * @returns {boolean} True if current state is internal.home
         */
        isHomeScreen() {
            return this.$state.is('internal.home');
        },

        /**
         * Go to fuel limit alert screen
         * @param {INotificationOptions} options - Additional options for handling the dialog
         * @returns {angular.IPromise<IPromise<any>>}
         */
        gotoFuelLimitAlert( options){
            return this.$timeout(()=>{
                return this.$state.go('internal.fuellimit', {
                    prevState: (options && options.isNotificationOnNotificationsModule) ? 'internal.notifications' : 'internal.home'
                });
            }, 500); // delay to fix error router when click on push notification (only iOS)
        },

        /**
         * Update notification count 
         * @param count{number}
         */
        updateNotificationCount(count) {
            this.notificationCountLoaded = true;
            this.notificationCount = count;
        },

        /**
         * @param options
         * @returns {angular.IPromise<IPromise<any>>}
         */
        gotoDocuments(options){
            return this.$timeout(()=>{
                return this.$state.go('internal.documents', {
                    prevState: (options && options.isNotificationOnNotificationsModule) ? 'internal.notifications' : 'internal.home'
                });
            }, 500); // delay to fix error router when click on push notification (only iOS)
        },

        /**
         * Set urgent UpdateRecommended
         * @param installUrl {string}
         */
        setUpdateRecommended(installUrl) {
            // Don't set if current urgent is UpdateRecommended
            if (this.currentNotificationUrgent && this.currentNotificationUrgent.Type === 'UpdateRecommended') {
                return;
            }

            
            this._updateRecommended = {
                Id: this.utilityService.createUUID(),
                KeyValueData: JSON.stringify({InstallUrl: installUrl}),
                Type: 'UpdateRecommended',
                Urgent: true,
                Unread: false,
            };
            this.checkUrgentNotifications(); // have to check urgent notifications immediately
        },

        /**
         * Set urgent WhatNews
         * @param news {object}
         */
        setWhatNews(news) {
            // Don't set if current urgent is WhatsNew
            if (this.currentNotificationUrgent  && this.currentNotificationUrgent.Type === 'WhatsNew') {
                return;
            }
            this._whatsNew = {
                Id: this.utilityService.createUUID(),
                KeyValueData: JSON.stringify(news),
                Type: 'WhatsNew',
                Urgent: true,
                Unread: false,
            }
            this.checkUrgentNotifications(); // have to check urgent notifications immediately
        }
    }
    NotificationService.$inject = ['$q', '$http', '$Config', 'AuthService', 'localStorageService', 'NetworkInfoService', '$message', '$state', 'DeviceService', '$mdPanel', '$Loading','$timeout', 'AnnouncementService', 'UtilityService', '$translationService'];
    return NotificationService;
}());
angular.module('shared').service('NotificationService', NotificationService);